import { environment } from "src/environments/environment"

export const ViewSettings = {
  otpInputConfig: {
    otpLength: 4,
    autofocus: true,
    classList: {
      inputBox: 'otpWrap',
      input: 'otpWrapInput',
      inputFilled: 'my-super-filled-class',
      inputDisabled: 'my-super-disable-class',
      inputSuccess: 'my-super-success-class',
      inputError: 'my-super-error-class',
    },
  }
}

export const fileDirectories = {
  admin: environment.BaseUrl + "admin/",
  business: environment.BaseUrl + "business/",
  deliveryAgent: environment.BaseUrl + "deliveryAgent/",
  assets: environment.BaseUrl + "assets/",
  inventory: environment.BaseUrl + "inventory/",
  order: environment.BaseUrl + "order/",
  replacement: environment.BaseUrl + "replacement/",
  pickups: environment.BaseUrl + "pickups/",
  category: environment.BaseUrl + "category/",
}

export const s3Folders = {
  admin: "admin/",
  business: "business/",
  deliveryAgent: "deliveryAgent/",
  assets: "assets/",
  category: "category/"
}

export function ordersStatisticsCards(ordersData: any) {
  return [
    { 'name': 'Total Orders', 'value': ordersData.totalOrders, 'iconName': 'totalOrderIcon' },
    { 'name': 'New Orders', 'value': ordersData.new, 'iconName': 'newOrdersIcon' },
    { 'name': 'Replacements', 'value': ordersData.replacementRequested, 'iconName': 'replacementIcon' },
    { 'name': 'Confirmed', 'value': ordersData.confirmed, 'iconName': 'confirmedIcon' },
    { 'name': 'Picked Up', 'value': ordersData.pickedUp, 'iconName': 'pickedIcon' },
    { 'name': 'Out For Delivery', 'value': ordersData.outOfDelivery, 'iconName': 'outIcon' },
    { 'name': 'Delivered', 'value': ordersData.delivered, 'iconName': 'deliveredOrderIcon' },
    { 'name': 'Completed', 'value': ordersData.completed, 'iconName': 'completedOrderIcon' },
    { 'name': 'Cancelled', 'value': ordersData.cancelled, 'iconName': 'cancelledOrderIcon' },
  ];
}

export function inventoryStatisticsCards(inventoryData: any) {
  return [
    { 'name': 'Total Items', 'value': inventoryData.totalCount, 'iconName': 'totalOrderIcon' },
    { 'name': 'Out Of Stock', 'value': inventoryData.outOfStockCount, 'iconName': 'outStockIcon' },
    { 'name': 'Low In Stock', 'value': inventoryData.LowInStockCount, 'iconName': 'lowIcon' }
  ];
}

export function pickedUpStatisticsCards(pickupData: any) {
  return [
    { 'name': 'All Pickups', 'value': pickupData?.allPickups, 'iconName': 'allPickup' },
    { 'name': 'Ready for pickup', 'value': pickupData?.readyForDelivery, 'iconName': 'readyPickup' },
    { 'name': 'Enroute for pickup', 'value': pickupData?.enrouteForPickup, 'iconName': 'outIcon' },
    { 'name': 'Completed', 'value': pickupData?.completed, 'iconName': 'completedOrderIcon' },
    { 'name': 'Received in warehouse', 'value': pickupData?.receivedInWarehouse, 'iconName': 'receivedIcon' },
    { 'name': 'Cancelled', 'value': pickupData?.cancelled, 'iconName': 'pickupCancelledIcon' }
  ];
}
export function invoicesStatisticsCards(invoiceStats: any) {
  return [
    { 'name': 'Businesses', 'value': invoiceStats?.totalBusinesses, 'iconName': 'businessIcon' },
    { 'name': 'Invoices', 'value': invoiceStats?.totalInvoiceCount, 'iconName': 'invoicesIcon' },
    { 'name': 'Total Order Amount', 'value': 'S$' + invoiceStats?.totalInvoiceAmount, 'iconName': 'amountIcon' },
    { 'name': 'Outstanding', 'value': 'S$' + invoiceStats?.totalOutstandingAmount, 'iconName': 'outstandingIcon' }
  ];
}

export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

